module.exports = __webpack_public_path__ + "static/media/Monument.5601304f.png";